import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from "react-bootstrap"

import { httpOk, GET, POST, PUT } from 'helpers/api'
import { formatDate, formatMoney, regexPhoneNumber } from "helpers/helpers"
import ExternalProvider from './ExternalProvider'

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [data, setData] = useState([])
	const [loyaltyTypes, setLoyaltyTypes] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalManual, setModalManual] = useState(false)
	const [modalWriteOff, setModalWriteOff] = useState(false)
	const [modalRegistration, setModalRegistration] = useState(false)
	// Внешняя система лояльности бренда (UDS и т.п.): включена — программы ниже не работают
	const [externalProvider, setExternalProvider] = useState(null)
	const [modalExternalProvider, setModalExternalProvider] = useState(false)
	// Участники программы для организаций — программа служит группой организаций
	const [modalMembers, setModalMembers] = useState(false)
	const [members, setMembers] = useState([])

	async function toggleModalMembers(bool = false, item = {}) {
		setSelectedItem(item)
		setMembers([])
		setModalMembers(bool)
		if (!bool) return

		const response = await GET(`/organizations?loyalty_service_id=${item.id}`, {}, { loader: true })
		if (httpOk(response)) setMembers(response.data?.data ?? [])
	}

	async function createUpdateRegistration(e) {
		e.preventDefault()

		var response
		if (!selectedItem.id) {
			response = await POST('/loyalty/services-registration', selectedItem, { loader: true })
		} else {
			response = await PUT('/loyalty/services-registration', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalRegistration()
		}
	}

	async function createUpdateManual(e) {
		e.preventDefault()

		var response
		if (!selectedItem.id) {
			response = await POST('/loyalty/services-manual', selectedItem, { loader: true })
		} else {
			response = await PUT('/loyalty/services-manual', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalManual()
		}
	}

	async function createUpdateWriteOff(e) {
		e.preventDefault()

		var response
		if (!selectedItem.id) {
			response = await POST('/loyalty/services-write-off', selectedItem, { loader: true })
		} else {
			response = await PUT('/loyalty/services-write-off', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalWriteOff()
		}
	}

	async function handleChangeStatus(e, type, index, id) {
		//var dataCopy = JSON.parse(JSON.stringify(data))

		var sendDta = {
			"id": id,
			"status": e.target.checked,
		}

		await PUT('/loyalty/services-status', sendDta, { loader: true })
		searchWithFilter()
	}

	async function handleChangeQrDefault(e, id) {
		await PUT('/loyalty/services-qr-default', {
			"id": id,
			"is_qr_default": e.target.checked,
		}, { loader: true })
		searchWithFilter()
	}

	// Программа бренда для организаций, у которых нет своей. Одна на бренд
	async function handleChangeOrganizationDefault(id, isDefault) {
		await PUT('/loyalty/services-organization-default', {
			"id": id,
			"is_organization_default": isDefault,
		}, { loader: true })
		searchWithFilter()
	}

	function goTo(item) {
		if (item.id === 1) {
			navigate('/loyalty/services/create-amount')
			return
		}

		if (item.id === 2) {
			navigate('/loyalty/services/create-saving')
			return
		}

		if (item.id === 3) {
			navigate('/loyalty/services/create-visit')
			return
		}

		if (item.id === 4) {
			toggleModalRegistration(true)
			return
		}

		if (item.id === 5) {
			toggleModalManual(true)
			return
		}
		if (item.id === 6) {
			toggleModalWriteOff(true)
			return
		}
	}

	function toggleModalRegistration(bool = false, item = {}) {
		setSelectedItem(item)
		setModalRegistration(bool)
	}

	function toggleModalManual(bool = false, item = {}) {
		setSelectedItem(item)
		setModalManual(bool)
	}

	function toggleModalWriteOff(bool = false, item = {}) {
		setSelectedItem(item)
		setModalWriteOff(bool)
	}

	async function searchWithFilter() {
		const response = await GET('/loyalty/services', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function getLoyaltyServiceTypes() {
		const response = await GET('/helper/loyalty-service-types', {}, { loader: true })
		if (httpOk(response)) setLoyaltyTypes(response.data)
	}

	async function getExternalProvider() {
		const response = await GET('/loyalty-provider')
		if (httpOk(response)) setExternalProvider(response.data?.provider ?? null)
	}

	useEffect(() => {
		searchWithFilter()
		getLoyaltyServiceTypes()
		getExternalProvider()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('loyalty')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<button type="button" className="btn btn-outline-primary"
						onClick={() => setModalExternalProvider(true)}>
						<i className="uil-link-alt me-1"></i>
						{externalProvider?.is_active ? externalProvider.name : t('loyalty_provider')}
					</button>
					<DropdownButton title={t('action')}>
						{loyaltyTypes.map((item, index) => (
							<Dropdown.Item key={index}
								onClick={() => goTo(item)}>
								{item.name}
							</Dropdown.Item>
						))}
					</DropdownButton>
				</div>
			</div>

			{!!externalProvider?.is_active &&
				<div className="alert alert-warning">
					{t('loyalty_provider_active_banner', { 'name': externalProvider.name })}
				</div>
			}

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }} >{t('name2')}</th>
									<th style={{ 'width': '15%' }} >{t('type')}</th>
									<th style={{ 'width': '15%' }} >{t('launch_date')}</th>
									<th style={{ 'width': '15%' }} >{t('stop_date')}</th>
									<th style={{ 'width': '10%' }} className="text-center text-nowrap">{t('status')}</th>
									<th style={{ 'width': '10%' }} className="text-center text-nowrap">{t('qr_cashback')}</th>
									<th style={{ 'width': '15%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={item.name}>
											{item.name}
											{item.audience === 'organizations' &&
												<span className="badge bg-primary ms-2">
													{t('for_organizations')}{item.is_organization_default ? ` · ${t('by_default')}` : ''}
												</span>
											}
										</td>
										<td className="td-ellipsis" title={item.service_name}>{item.service_name}</td>
										<td>{formatDate(item.start_at, 'dd.MM.yy HH:mm')}</td>
										<td>{formatDate(item.stop_at, 'dd.MM.yy HH:mm')}</td>
										<td>
											<div className="form-check form-switch form-switch-md justify-content-center">
												<input type="checkbox" className="form-check-input" name="status"
													checked={item.status}
													onChange={(e) => handleChangeStatus(e, 'checkbox', index, item.id)} />
											</div>
										</td>
										<td>
											{/* Программа, по которой начисляет QR на чеке. Она одна на бренд:
												гость, отсканировавший чек, между программами не выбирает. */}
											{[1, 2, 3].includes(item.loyalty_service_type_id) && item.audience !== 'organizations' &&
												<div className="form-check form-switch form-switch-md justify-content-center">
													<input type="checkbox" className="form-check-input" name="is_qr_default"
														checked={!!item.is_qr_default}
														onChange={(e) => handleChangeQrDefault(e, item.id)} />
												</div>
											}
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{/* «По визитам» оптовым покупателям не подходит, поэтому только типы 1 и 2 */}
														{[1, 2].includes(item.loyalty_service_type_id) && item.audience === 'organizations' &&
															<div className="table-dropdown-item"
																onClick={() => handleChangeOrganizationDefault(item.id, !item.is_organization_default)}>
																<i className="uil-building"></i>
																{item.is_organization_default ? t('org_program_unset_default') : t('org_program_set_default')}
															</div>
														}
														{[1, 2].includes(item.loyalty_service_type_id) && item.audience === 'organizations' &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalMembers(true, item)}>
																<i className="uil-users-alt"></i>
																{t('org_program_members')}
															</div>
														}
														{item.loyalty_service_type_id === 1 &&
															<Link to={`/loyalty/services/update-amount/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 2 &&
															<Link to={`/loyalty/services/update-saving/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 3 &&
															<Link to={`/loyalty/services/update-visit/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 4 &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalRegistration(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														}
														{item.loyalty_service_type_id === 5 &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalManual(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL MEMBERS */}
			<Modal show={modalMembers} animation={false} centered size="lg"
				onHide={() => toggleModalMembers()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('org_program_members')}: {selectedItem.name} [{members.length}]
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* Организации без своей программы сюда не попадают, даже если эта программа — по умолчанию */}
					{selectedItem.is_organization_default &&
						<p className="text-muted">{t('org_program_members_default_hint')}</p>
					}
					<div className="table-responsive" style={{ 'maxHeight': '60vh' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '40%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('phone')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('org_personal_cashback')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('org_cashback')}</th>
								</tr>
							</thead>
							<tbody>
								{members.map((member, index) => (
									<tr key={member.id}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={member.name}>{member.name}</td>
										<td className="text-nowrap">{regexPhoneNumber(member.phone)}</td>
										<td className="text-end text-nowrap">
										{member.loyalty_amount !== null && `${formatMoney(member.loyalty_amount)} ${t('org_award_per_cheque')}`}
										{member.loyalty_percent !== null && `${Number(member.loyalty_percent)}%`}
									</td>
										<td className="text-end text-nowrap">{formatMoney(member.loyalty_balance)}</td>
									</tr>
								))}
								{members.length === 0 &&
									<tr>
										<td colSpan="5" className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
					<p className="text-muted mt-2 mb-0">{t('org_program_members_hint')}</p>
				</Modal.Body>
			</Modal>
			{/* MODAL MEMBERS */}

			{/* MODAL REGISTRATION */}
			<Modal show={modalRegistration} animation={false} centered
				onHide={() => toggleModalRegistration()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdateRegistration} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('amount')}</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9]/gi, '') })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalRegistration()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL REGISTRATION */}

			{/* MODAL MANUAL */}
			<Modal show={modalManual} animation={false} centered
				onHide={() => toggleModalManual()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdateManual} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('max')}</label>
							<input type="text" className="form-control" name="max_amount"
								value={selectedItem.max_amount}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'max_amount': e.target.value.replace(/[^0-9]/gi, '') })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalManual()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL MANUAL */}

			{/* MODAL WRITEOFF */}
			<Modal show={modalWriteOff} animation={false} centered
				onHide={() => toggleModalWriteOff()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdateWriteOff} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalWriteOff()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL WRITEOFF */}

			{/* MODAL EXTERNAL PROVIDER */}
			<ExternalProvider
				show={modalExternalProvider}
				onHide={() => setModalExternalProvider(false)}
				onChange={(data) => setExternalProvider(data?.provider ?? null)}
			/>
			{/* MODAL EXTERNAL PROVIDER */}
		</>
	)
}

export default Index